import React from 'react'
import SyncButton from '../../ui/sync-button'
import { regHolderBasePath } from '../../reg-holder'

const ForceSyncButton = ({ regHolder, onComplete, start_date}) => (
  <SyncButton
    steps={[
      {
        syncPath: regHolderBasePath(regHolder) + `/session-reports/sync-for-week/?week_start=${start_date}`,
        text: 'Pulling records from government'
      }
    ]}
    onComplete={onComplete}
  />
)

export default ForceSyncButton



// WEBPACK FOOTER //
// ./src/session-summaries/views/force-sync-button.jsx